import { useState, useEffect } from "react";
import clinicianSignUp from "../assets/images/clinicianSignUp.png";
import patientSignUp from "../assets/images/patientSignUp.png";
import { useNavigate } from "react-router-dom";

const Unverified = () => {
    const navigate = useNavigate();

    return (
        <div style={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            
                <div className="col centerAlign" style={{ margin: "auto", width: "60%" }}>
                    <div className="h1 hippiBlue">
                       THANK YOU
                    </div>
                    <div className="col" style={{ padding: "2rem 0" }}>
                    <div className="col b2 midGray textCenter">Thank you for registering! You will receive an email shortly. If you do not receive an email, please contact support at <a className="hippieBlue" href="mailto:support@support.com" >support@support.com</a>.</div>
                    <button className="button1 h3" onClick={() => navigate("/signin")}>LOGIN</button>
                    </div>
                </div>
            
        </div>
    );
};

export default Unverified;